// extracted by mini-css-extract-plugin
var _1 = "j5Sif";
export { _1 as "base" }
